class Tabs {
	constructor(containerEl) {
		this._handleSwitchTab = this._handleSwitchTab.bind(this);

		this._containerEl = containerEl;
		this._contentList = Array.from(containerEl.children);
		this._activeIndex = 0;
		this._tabHeadings = this._contentList.map(
			(contentEl) => contentEl.firstElementChild
		);
		this._containerEl.prepend(this._createTabButtons());
		this.switchToTab(this._activeIndex);
		this._containerEl.classList.add('tabs--initialized');
	}

	_createTabButtons() {
		const tabButtonsEl = document.createElement('div');
		tabButtonsEl.classList.add('tabs__buttons');
		this._tabHeadings.forEach((headingEl, index) => {
			const tabButtonEl = document.createElement('button');
			tabButtonEl.classList.add('tabs__button', 'tabs__section-title');
			tabButtonEl.dataset.tabIndex = index;
			tabButtonEl.innerHTML = headingEl.innerHTML;
			tabButtonEl.type = 'button';
			tabButtonEl.ariaPressed = index === 0;
			tabButtonEl.addEventListener('click', this._handleSwitchTab);
			tabButtonsEl.append(tabButtonEl);
		});
		this._tabButtonList = Array.from(tabButtonsEl.children);
		return tabButtonsEl;
	}

	_handleSwitchTab(event) {
		this.switchToTab(event.target.dataset.tabIndex);
	}

	switchToTab(index) {
		this._contentList[this._activeIndex].classList.remove(
			'tabs__section--visible'
		);
		this._tabButtonList[this._activeIndex].ariaPressed = false;
		this._activeIndex = parseInt(index);
		this._tabButtonList[this._activeIndex].ariaPressed = true;
		this._contentList[this._activeIndex].classList.add(
			'tabs__section--visible'
		);
	}
}

document
	.querySelectorAll('.wp-block-occasions-tabs')
	.forEach((el) => new Tabs(el));
